import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {logout} from 'mb-app-common/store/actions/auth'
import {withRouter} from 'react-router-dom'

export class Logout extends PureComponent{
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		history: PropTypes.object.isRequired
	}

	componentDidMount(){
		this.props.dispatch(logout())
			.then(() => this.props.history.push('/login'))
	}

	render(){
		return null
	}
}


export default connect(() => ({}))(withRouter(Logout))



// WEBPACK FOOTER //
// ./client/components/Logout/index.js